/**
 * @generated SignedSource<<5a8187bcb2cefe914351af96c8621932>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentProvider_charge$data = {
  readonly isShopifyCharge: boolean | null | undefined;
  readonly redirectUrl: string | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentType": "PaymentProvider_charge";
};
export type PaymentProvider_charge$key = {
  readonly " $data"?: PaymentProvider_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentProvider_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentProvider_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redirectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShopifyCharge",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "8ac540591a9e245b85b7e80b9a7a79d9";

export default node;
